import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '../utils/formatDate';

@Pipe({ name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '';

    return formatDate(value);
  }
}
